const TOAST_CONTAINER_ID = 'global-toast-container';

function getToastContainer() {
  let container = document.getElementById(TOAST_CONTAINER_ID);
  if (container) return container;

  container = document.createElement('div');
  container.id = TOAST_CONTAINER_ID;
  Object.assign(container.style, {
    position: 'fixed',
    top: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    zIndex: '9999',
    pointerEvents: 'none',
  });

  document.body.appendChild(container);
  return container;
}

// Paleta por tipo de toast (sucesso: verde, erro: vermelho).
const TOAST_VARIANTS = {
  success: { background: '#064e3b', color: '#ecfdf5', border: '1px solid #065f46' },
  error: { background: '#7f1d1d', color: '#fef2f2', border: '1px solid #991b1b' },
};

// Toast leve e reutilizavel para feedback de acoes, sem depender de bibliotecas externas.
// Erros ficam um pouco mais tempo em tela para dar tempo de leitura.
function showToast(message, variant = 'success') {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const palette = TOAST_VARIANTS[variant] || TOAST_VARIANTS.success;
  const container = getToastContainer();
  const toast = document.createElement('div');

  Object.assign(toast.style, {
    minWidth: '240px',
    maxWidth: '360px',
    background: palette.background,
    color: palette.color,
    borderRadius: '12px',
    border: palette.border,
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.18)',
    padding: '12px 14px',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '1.4',
    textAlign: 'center',
    opacity: '0',
    transform: 'translateY(-8px)',
    transition: 'opacity 180ms ease, transform 180ms ease',
    pointerEvents: 'none',
  });

  toast.textContent = message;
  container.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';
  });

  const duration = variant === 'error' ? 3600 : 2600;
  window.setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-8px)';

    window.setTimeout(() => {
      toast.remove();
    }, 180);
  }, duration);
}

export function showSuccessToast(message = 'Cadastro feito com sucesso.') {
  showToast(message, 'success');
}

export function showErrorToast(message = 'Não foi possível concluir a ação.') {
  showToast(message, 'error');
}
